import styled from 'styled-components'
import { Flex, Button, Input } from 'uikit'

export const FormCon = styled(Flex)`
  background: #47299B;
  border-radius: 6px;
  margin-top: 20px;
`

export const FormLeft = styled.div`
  padding: 5px 10px;
  width: calc(100% - 100px);
`

export const FormInput = styled(Input)`
  font-size: 20px;
  background-color: transparent;
  box-shadow: none;
  height: fit-content;
  padding: 0 5px 0 0;
  border-radius: 0px;

  :focus:not(:disabled) {
    box-shadow: none;
  }
`

export const Max = styled(Button)`
  font-size: 15px;
  font-weight: 600;
  padding: 0;
  background: transparent;
  box-shadow: none;
  height: auto;
`
